import { Component, Input, OnInit } from '@angular/core';
import { LabelStyle, LabelType } from '@core/models/enums/common.enum';
import { LabelModel } from '@core/models/models';

@Component({
  selector: 'caremoni-label',
  templateUrl: './label.component.html',
  styleUrl: './label.component.scss'
})
export class LabelComponent implements OnInit {
  // có 4 type (default, label in icon, )
  @Input() labelType: LabelType = LabelType.DEFAULT;
  @Input() disabled: boolean = false;
  @Input() labelStyle: LabelStyle  = LabelStyle.TEXT_IS_BELLOW_ICON;
  @Input() labelText: string = ''; 
  @Input() cssStyle: LabelModel = new LabelModel();
  LabelType = LabelType;

  constructor() { }

  ngOnInit(): void {
    // trường hợp text nằm dưới icon
    if(this.labelStyle == LabelStyle.TEXT_IS_BELLOW_ICON) {
      // set width, height mặc định cho icon
      this.cssStyle.width = !this.cssStyle?.width ?  '30px' : this.cssStyle.width;
      this.cssStyle.height = !this.cssStyle?.height ?  '30px' : this.cssStyle.height;
    }
  }
}